import { useEffect } from 'react';
import { Loader2 } from 'lucide-react';
import { useQualityDashboardStore } from '@/stores/qualityDashboard';

export function CoverageTrendSparkline() {
  const { coverageTrend, trendLoading, fetchCoverageTrend } =
    useQualityDashboardStore();

  useEffect(() => {
    fetchCoverageTrend(30);
  }, [fetchCoverageTrend]);

  if (trendLoading && coverageTrend.length === 0) {
    return (
      <div className="text-xs text-slate-400 text-center py-4">
        <Loader2 size={12} className="animate-spin inline mr-1" />
        Loading trend...
      </div>
    );
  }

  if (coverageTrend.length === 0) {
    return (
      <div className="text-xs text-slate-400 text-center py-4">
        No new canonicals in the last 30 days.
      </div>
    );
  }

  const width = 320;
  const height = 48;
  const max = Math.max(...coverageTrend.map((d) => d.count), 1);
  const step = coverageTrend.length > 1 ? (width - 4) / (coverageTrend.length - 1) : 0;
  const points = coverageTrend
    .map((d, i) => {
      const x = 2 + i * step;
      const y = 2 + (1 - d.count / max) * (height - 4);
      return `${x},${y}`;
    })
    .join(' ');
  const total = coverageTrend.reduce((s, d) => s + d.count, 0);

  return (
    <div className="bg-white rounded-xl border border-slate-200 p-4">
      <div className="flex items-center justify-between mb-2">
        <div>
          <h3 className="text-xs font-semibold text-navy-900">
            New canonicals — last 30 days
          </h3>
          <p className="text-[10px] text-slate-500 mt-0.5">
            {total} total · peak {max}/day
          </p>
        </div>
      </div>
      <svg width={width} height={height}>
        <polyline
          fill="none"
          stroke="currentColor"
          strokeWidth={1.5}
          className="text-brand-teal"
          points={points}
        />
      </svg>
    </div>
  );
}
